

import { registerVueComponent, declareVrunModule, vrunAutoNgVueWraper } from '/vodalys/vvuejs'

import VonageCapture from './components/VonageCapture.vue'

registerVueComponent('vonage.capture.vrun', 'VonageCapture', VonageCapture)

const ngModule = declareVrunModule('vonage.capture.vrun');
vrunAutoNgVueWraper(ngModule, 'vonageCapture.vrun.component', 'vonageCapture', VonageCapture)